function additionalClinicianResetSideEffect(
  checked: boolean,
  setFieldValue: Function,
  setFieldTouched: Function
) {
  if (!checked) {
    setFieldValue("additionalClinician", []);
  }
  setTimeout(() => {
    setFieldTouched("additionalClinician", true);
  }, 500);
}
export default additionalClinicianResetSideEffect;
